// Portions of this code are adapted from the MUI Toolbar component.
// Source: https://github.com/mui/toolpad/blob/master/packages/toolpad-core/src/DashboardLayout/AppTitle.tsx
// MUI is licensed under the MIT License: https://github.com/mui/toolpad/blob/master/LICENSE

import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { Link as RouterLink } from "react-router";
import Typography from "@mui/material/Typography";
import { Branding } from "../../types";
import Link from "@mui/material/Link";

const LogoContainer = styled('div')({
    position: 'relative',
    height: 40,
    display: 'flex',
    alignItems: 'center',
    '& img': {
        maxHeight: 40,
    },
});

export interface AppTitleProps {
    branding: Branding;
}

export function AppTitle(props: AppTitleProps) {
    // get branding properties
    const { title, logo, homeUrl } = props.branding;

    // if no title or logo is provided, return null
    if (!title && !logo) {
        return null;
    }

    return (
        <Link
            color="inherit"
            underline="none"
            component={RouterLink}
            to={homeUrl ?? '/'}
        >
            <Stack direction="row" alignItems="center" spacing={1}>
                <LogoContainer>{logo}</LogoContainer>
                <Typography
                    display={{ xs: 'none', md: 'block' }}
                    variant="h6"
                    sx={{
                        fontWeight: '700',
                        whiteSpace: 'nowrap',
                        lineHeight: 1,
                    }}
                >
                    {title}
                </Typography>
            </Stack>
        </Link>
    );
}

export default AppTitle;